import React from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

function LocationMarker({ position, setPosition }) {
  useMapEvents({
    click(e) {
      setPosition(e.latlng);
    },
    contextmenu(e) { // right click
      setPosition(e.latlng);
    }
  });

  return position === null ? null : (
    <Marker position={position}></Marker>
  );
}

export default function LocationPicker({ lat, lng, setLat, setLng }) {
  const position = (lat && lng && !isNaN(lat) && !isNaN(lng)) ? { lat: parseFloat(lat), lng: parseFloat(lng) } : null;

  return (
    <MapContainer 
      center={position || { lat: 51.9194, lng: 19.1451 }} 
      zoom={position ? 15 : 6} 
      style={{ height: '300px', width: '100%', borderRadius: '8px', zIndex: 0 }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <LocationMarker 
        position={position} 
        setPosition={(pos) => {
          setLat(pos.lat.toFixed(6));
          setLng(pos.lng.toFixed(6));
        }} 
      />
    </MapContainer>
  );
}
